__turbopack_context__.v({
  "categorySuggestionText": "eOWJCq_categorySuggestionText",
  "lensIcon": "eOWJCq_lensIcon",
  "searchSuggestion": "eOWJCq_searchSuggestion",
  "searchSuggestionText": "eOWJCq_searchSuggestionText",
  "searchSuggestionTextVariant": "eOWJCq_searchSuggestionTextVariant",
  "searchSuggestionVariantA": "eOWJCq_searchSuggestionVariantA",
  "searchSuggestionVariantB": "eOWJCq_searchSuggestionVariantB",
  "suggestionList": "eOWJCq_suggestionList",
  "textWithEllipsis": "eOWJCq_textWithEllipsis",
  "wrapper": "eOWJCq_wrapper",
});
